import { useTranslation } from "react-i18next";

import { ColumnFiltersState } from "@tanstack/react-table";

import { FilterHeader } from "./FilterHeader";

type Props = {
    columnFilters: ColumnFiltersState;
    setColumnFilters: React.Dispatch<React.SetStateAction<ColumnFiltersState>>;
};
export const EventLevelHeader = ({ columnFilters, setColumnFilters }: Props) => {
    const { t } = useTranslation(["sidepanels", "common"]);
    const current = (columnFilters.find((f) => f.id === "eventLevel")?.value as string[] | undefined) ?? [];

    return (
        <FilterHeader
            title={t("common:table.filter.eventType")}
            sortDisabled
            options={[
                { key: "notice", label: t("common:table.filter.notice") },
                { key: "warning", label: t("common:table.filter.warning") },
            ]}
            initialValues={{
                notice: current.includes("notice"),
                warning: current.includes("warning"),
            }}
            onSubmit={(values) => {
                const value = Object.keys(values).filter((k) => values[k]);
                setColumnFilters((prev) => {
                    const rest = prev.filter((f) => f.id !== "eventLevel");
                    return value.length ? [{ id: "eventLevel", value }, ...rest] : rest;
                });
            }}
        />
    );
};
